import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) source.setAttribute('src', videoSource);
    }

    videoElement.load();
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}

// Play once, click to replay, no controls
function setupVideoPlayOnce() {
  const section = document.querySelector('#shopify-section-template--28532936147328__section_4GHDKf');
  if (!section) return;
  const video = section.querySelector('video');
  if (!video) return;

  // Remove loop
  video.loop = false;
  video.muted = false;
  video.play();

  // Click to replay
  video.addEventListener('ended', function() {
    video.pause();
    video.currentTime = 0;
  });

  section.addEventListener('click', function() {
    video.currentTime = 0;
    video.play();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupVideoPlayOnce);
} else {
  setupVideoPlayOnce();
}





